/* eslint-disable import/no-cycle */
import React from 'react';
import Description from './TsDocComment';
import Members from './TsDocMembers';
import ReturnBlock from './TsDocReturnBlock';
import { getFunctionNode } from './utils/tsDocTypeExpression';

var TsDocBlock = function TsDocBlock(_ref) {
  var definition = _ref.definition,
      hideReturns = _ref.hideReturns,
      _ref$hideProperties = _ref.hideProperties,
      hideProperties = _ref$hideProperties === void 0 ? !!getFunctionNode(definition) : _ref$hideProperties,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 2 : _ref$depth;
  if (!definition) return null;
  var nextDepth = depth + 1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description, {
    comment: definition.description
  }), /*#__PURE__*/React.createElement(Members, {
    depth: nextDepth,
    definition: definition,
    hideProperties: hideProperties
  }), !hideReturns && /*#__PURE__*/React.createElement(ReturnBlock, {
    depth: nextDepth,
    definition: definition
  }));
};

export default TsDocBlock;